<template>
    <div v-if="!sameInvoiceAddress" >
        <h3 class="order-address-form__sub-heading">Rechnungsadresse</h3>
        <div class="order-address-form__form-group form-group">
            <firm
                v-if="mode === 'business'"
                :required="firmRequired"
            />
            <email />
        </div>
        <div class="order-address-form__form-group form-group">
            <prename />
            <surname/>
        </div>
        <div class="order-address-form__form-group form-group">
            <floor-department/>
            <street/>
        </div>
        <div class="order-address-form__form-group form-group">
            <div class="order-address-form__form-group-item order-address-form__form-group-item">
                <div class="order-address-form__zip-place-container">
                    <postal-code/>
                    <place/>
                </div>
            </div>
            <phone/>
        </div>
        <div class="order-address-form__form-group form-group">
            <mobile-phone/>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { validationMixin } from 'vuelidate';
import {
    required,
    minLength,
    maxLength,
    numeric,
    email,
} from 'vuelidate/lib/validators';
import { mapState } from 'vuex';

import Firm from './Fields/Firm.vue';
import Email from './Fields/Email.vue';
import Prename from './Fields/Prename.vue';
import Surname from './Fields/Surname.vue';
import FloorDepartment from './Fields/FloorDepartment.vue';
import Street from './Fields/Street.vue';
import PostalCode from './Fields/PostalCode.vue';
import Place from './Fields/Place.vue';
import Phone from './Fields/Phone.vue';
import MobilePhone from './Fields/MobilePhone.vue';

export default {
    components: {
        Firm,
        Email,
        Prename,
        Surname,
        FloorDepartment,
        Street,
        PostalCode,
        Place,
        Phone,
        MobilePhone,
    },
    mixins: [validationMixin],
    props: {
        firmRequired: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        const invoiceAddress = _.cloneDeep(this.$store.state.order.invoice_address);
        return {
            address: 'invoiceAddress',
            form: {
                invoiceAddress,
            },
        };
    },
    computed: {
        ...mapState({
            mode: state => state.mode,
            sameInvoiceAddress: state => state.sameInvoiceAddress,
            initInvoiceAddress: state => state.order.invoice_address,
        }),
    },
    watch: {
        initInvoiceAddress: {
            deep: true,
            handler() {
                this.form.invoiceAddress = this.initInvoiceAddress;
            },
        },
    },
    validations() {
        const invoiceAddress = {
            email_contact: {
                required,
                email,
            },
            firstname: {
                required,
            },
            lastname: {
                required,
            },
            street: {
                required,
            },
            zip: {
                required,
                numeric,
                minLength: minLength(4),
                maxLength: maxLength(4),
            },
            city: {
                required,
            },
            phone: {
                required,
            },
        };
        if (!this.sameInvoiceAddress) {
            if (this.mode === 'business' && this.firmRequired) {
                return {
                    form: {
                        invoiceAddress: {
                            ...invoiceAddress,
                            company: {
                                required,
                            },
                        },
                    },
                };
            }
            return {
                form: {
                    invoiceAddress,
                },
            };
        }
        return {
            form: {},
        };
    },
};
</script>



// WEBPACK FOOTER //
// InvoiceAddress.vue?6d5e7901